import { useEffect, useState } from "react";

import { API_ORIGIN } from "@/constants";

export function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(handler);
  }, [value, delay]);
  return debouncedValue;
}

export function isDevelopment(): boolean {
  return import.meta.env.DEV;
}

export function isStaging(): boolean {
  return (
    import.meta.env.PROD && API_ORIGIN === "https://api.preview.myvictoria.io"
  );
}

export function isProduction(): boolean {
  return import.meta.env.PROD;
}
